module.exports = __webpack_public_path__ + "static/media/warning.f3516999.svg";